<mat-dialog-content>
  <!-- Header Section with Dynamic Title -->
  <div style="display: flex; justify-content: space-between; align-items: center;">
    <h1 style="font-size: 1.5rem">
      {{ isEdit ? 'Edit Organization' : 'Create Organization' }}
    </h1>

    <lib-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </lib-icon-button>
  </div>

  <!-- Loading State -->
  @if (loading) {
    <lib-content-loader></lib-content-loader>
  }

  <!-- Form Section -->
  @if (!loading) {
    <div [formGroup]="form">
      <mat-form-field class="full-width" appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput type="text" formControlName="name" placeholder="Enter organization name">
      </mat-form-field>

      <!-- Checkbox with Dynamic Label -->
      <mat-checkbox color="primary" formControlName="require_approval">
        Would you like to {{ isEdit ? 'continue approving' : 'approve' }} this organization's reports prior to allowing them to see their results?
      </mat-checkbox>
    </div>
  }
</mat-dialog-content>

<!-- Action Buttons -->
<mat-dialog-actions style="gap: 0.8rem; padding: 0 2rem 1rem" align="end">
  <lib-button color="primary" mat-button mat-dialog-close>
    Cancel
  </lib-button>

  <!-- Button Text Changes Dynamically Based on Mode -->
  <lib-button
    color="primary"
    mat-button
    (click)="saveOrganization()"
    [disabled]="form.invalid || loading">
    {{ isEdit ? 'Save' : 'Create' }}
  </lib-button>
</mat-dialog-actions>
